import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, Inbox, FileCheck2, CircleCheck, BookOpen, ArrowRight } from 'lucide-react';
import { Ticket, Stats } from '../lib/types';
import { Badge, Priority } from './Common';

const METRICS = [
  {key: 'active', label: 'Open conversations', icon: Inbox, tint: 'coral'},
  {key: 'drafted', label: 'Ready for review', icon: FileCheck2, tint: 'blue'},
  {key: 'resolved', label: 'Resolved', icon: CircleCheck, tint: 'green'},
  {key: 'articles', label: 'Knowledge documents', icon: BookOpen, tint: 'neutral'},
] as const;

export const WorkspaceStats = ({stats}: {stats: Stats | null}) => <div className="stats-band">
  {METRICS.map((metric, index) => <div className="stat-item" key={metric.key}>
    <span className={`stat-icon ${metric.tint}`}><metric.icon size={19} strokeWidth={1.5}/></span>
    <div><span data-testid={`stat-label-${index}`}>{metric.label}</span><strong data-testid={`stat-value-${index}`}>{stats?.[metric.key] ?? '—'}</strong></div>
    {metric.key === 'articles' && <Link to="/kb" title="Manage knowledge base" className="stat-link" data-testid="stat-kb-link"><ArrowUpRight size={17}/></Link>}
  </div>)}
</div>;

export const RecentConversations = ({tickets, total}: {tickets: Ticket[]; total: number}) => <section className="recent-section">
  <div className="section-heading"><h2 data-testid="recent-tickets-heading">Recent conversations <span>{total}</span></h2><Link data-testid="view-all-tickets-link" to="/tickets">View ticket log<ArrowRight size={14}/></Link></div>
  {tickets.length ? <div className="recent-list">{tickets.slice(0, 3).map(ticket => <Link key={ticket.id} to={`/ticket/${ticket.id}`} className="recent-row" data-testid={`recent-ticket-${ticket.id}`}>
    <span className="ticket-number">{ticket.number}</span><strong>{ticket.title || 'Untitled conversation'}</strong>
    <Priority value={ticket.priority} testId={`recent-priority-${ticket.id}`}/><Badge value={ticket.status} testId={`recent-status-${ticket.id}`}/><ArrowUpRight size={15}/>
  </Link>)}</div> : <div className="recent-empty" data-testid="recent-empty"><Inbox size={18}/><span>A clear desk. Your conversations will collect here.</span><span>Ready when you are.</span></div>}
</section>;